import React from 'react';
import './VaultCard.scss';
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import {lighten} from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";

const BorderLinearProgress = withStyles({
  root: {
    height: 20,
    backgroundColor: lighten('#ffffff', 0.5),
    borderRadius: 8,
    border: "1px solid #D4D4D4"
  },
  bar: {
    borderRadius: 8,
  },
})(LinearProgress);

const ErrorLinearProgress = withStyles({
  root: {
    border: "1px solid #A54657"
  },
  barColorPrimary: {
    backgroundColor: '#A54657',
  },
})(BorderLinearProgress);


function FreeTrialCard(props) {
  return <>
    {
      props.user && props.user.subscriptionType === 'FREE_TRIAL' &&
      <Paper className="activity-log-card mb-6">

        <div className="text-left dashboard-sidebar-title">
          <span className="font-bold uppercase-text">Free Trial</span>
        </div>
        <div className="user-activity-card-content">
          {
            props.user.trialDaysRemaining > 7 ?
              <BorderLinearProgress variant="determinate" value={100 * ((props.user.trialDaysRemaining / 21) ) } />
              :
              <ErrorLinearProgress variant="determinate" value={props.user.trialDaysRemaining ? 100 * ((props.user.trialDaysRemaining / 21) ) : 100} />
          }
          <div className="flex items-center justify-between mt-4">
            <p className={`${props.user.trialDaysRemaining ? 'text-grey' : 'text-alert'} uppercase`}>{ props.user.trialDaysRemaining } Day{props.user.trialDaysRemaining === 1 ? '': 's'} LEFT</p>
            <a className="text-secondary uppercase" onClick={() => props.toggleAccountPreferencesModal(true)}>Upgrade</a>
          </div>
        </div>
      </Paper>
    }
  </>
};

export default FreeTrialCard;
